<template>
  <div style="background: #FFFFFF;height:800px;overflow-y: auto;">
    <el-row class="accountView">
      <el-col class="imageView" :span="3">
        <el-upload
            class="infoImage"
            action="https://jsonplaceholder.typicode.com/posts/"
            :show-file-list="false"
            :http-request="cutomUpload"
            :before-upload="beforeUpload">
          <img :src="userInfo.headPortrait !== null ? userInfo.headPortrait: require('../../../assets/img/pages/tou.png')" class="avatar">
        </el-upload>
      </el-col>
      <el-col class="infoView" :span="21">
        <div class="title" style="padding-top: 30px;">账号信息</div>
        <div class="infocell">
          <el-col class="accountKey" :span="4">昵称</el-col>
          <el-col class="accountValue" :span="18">{{ userInfo.name }}<el-button class="changeBtn" type="text" @click="nickNameClick()">修改</el-button></el-col>
          <el-col class="accountValue" :span="2">
            <el-button v-show="!isCheckIn" class="checkButton" size="medium" round @click="checkClick()">签到</el-button>
            <el-button v-show="isCheckIn" class="checkedButton" size="medium" round>已签到</el-button>
          </el-col>
        </div>
        <div v-if="userInfo.source === '1'" class="infocell">
          <el-col class="accountKey" :span="4">手机号</el-col>
          <el-col class="accountValue" :span="20">{{ userInfo.phone }}<el-button class="changeBtn" type="text" @click="phoneClick()">修改</el-button></el-col>
        </div>
        <div v-else-if="userInfo.source === '2'" class="infocell">
          <el-col class="accountKey" :span="4">邮箱</el-col>
          <el-col class="accountValue" :span="20">{{ userInfo.email }}<el-button class="changeBtn" type="text" @click="emailClick()">修改</el-button></el-col>
        </div>
        <div v-else-if="userInfo.source === '3'" class="infocell">
          <el-col class="accountKey" :span="4">邮箱</el-col>
          <el-col class="accountValue" :span="20">{{ userInfo.email }}</el-col>
        </div>
        <div class="infocell">
          <el-col class="accountKey" :span="4">密码</el-col>
          <el-col class="accountValue" :span="20">******<el-button v-if="userInfo.source !== '3'" class="changeBtn" type="text" @click="setPasswordClick()">设置/修改</el-button></el-col>
        </div>
        <el-divider></el-divider>
        <div class="title">基本信息</div>
        <div class="infocell">
          <el-col class="accountKey" :span="4">性别</el-col>
          <el-col v-if="userInfo.sex === '0' || userInfo.sex === null" class="accountValue" :span="20">未公开<el-button class="changeBtn" type="text" @click="sexClick()">修改</el-button></el-col>
          <el-col v-if="userInfo.sex === '1'" class="accountValue" :span="20">男<el-button class="changeBtn" type="text" @click="sexClick()">修改</el-button></el-col>
          <el-col v-if="userInfo.sex === '2'" class="accountValue" :span="20">女<el-button class="changeBtn" type="text" @click="sexClick()">修改</el-button></el-col>
        </div>
        <div class="infocell">
          <el-col class="accountKey" :span="4">生日</el-col>
          <el-col class="accountValue" :span="20">{{ showBirthday }}<el-button class="changeBtn" type="text" @click="birthdayClick()">修改</el-button></el-col>
        </div>
        <div v-if="userInfo.source === '1'" class="infocell">
          <el-col class="accountKey" :span="4">邮箱</el-col>
          <el-col class="accountValue" :span="20">{{ userInfo.email }}<el-button class="changeBtn" type="text" @click="emailClick()">修改</el-button></el-col>
        </div>
        <div v-else class="infocell">
          <el-col class="accountKey" :span="4">手机号</el-col>
          <el-col class="accountValue" :span="20">{{ userInfo.phone }}<el-button class="changeBtn" type="text" @click="phoneClick()">修改</el-button></el-col>
        </div>
        <div class="infocell">
          <el-col class="accountKey" :span="4">个人介绍</el-col>
          <el-col class="accountValue" :span="20">{{ userInfo.introduce }}<el-button class="changeBtn" type="text" @click="introducClick()">修改</el-button></el-col>
        </div>
        <el-divider></el-divider>
        <div class="title">登录记录</div>
        <el-col class="levelDetails" :span="24">由于您的带宽运营商会不定期的调整网络，我们获取的ip所在的地址可能不准确，请您通过登入时间与系统判断是否为您本人操作；如确定非您本人登录，建议您修改密码。</el-col>
        <el-col class="levelTable" :span="18">
          <el-table
              :data="tableData"
              :header-cell-style="{'text-align':'center','background':'#EEF7FF'}"
              :cell-style="{'text-align':'center'}"
              border
              stripe
              style="width: 100%;">
            <el-table-column
                label="日期">
              <template slot-scope="scope">
               {{ getMilliData(scope.row.insertTime) }}
              </template>
            </el-table-column>
            <el-table-column
                label="时间">
              <template slot-scope="scope">
                {{ getMilliHours(scope.row.insertTime) }}
              </template>
            </el-table-column>
            <el-table-column
                prop="clientIp"
                label="IP">
            </el-table-column>
<!--            <el-table-column-->
<!--                prop="territory"-->
<!--                label="IP所属地">-->
<!--            </el-table-column>-->
          </el-table>
        </el-col>
        <el-col :span="24" style="margin: 164px 0px 40px 0px">
          <el-button type="primary" @click="logoutClick()">退出当前账号</el-button>
          <el-button type="warning" style="margin-left: 20px !important;" @click="logoffClick()">注销当前账号</el-button>
        </el-col>
      </el-col>
    </el-row>
    <el-dialog
        title="修改昵称"
        :visible.sync="nicknameDialog"
        width="30%"
        :before-close="handleClose"
        :close-on-click-modal="false">
      <el-form :model="changeUserInfo">
        <el-form-item>
          <el-input v-model="changeUserInfo.username" maxlength="20" placeholder="请输入昵称" autocomplete="off" @input="nicknameChangeClick()"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" round :disabled="nicknameDisabled" @click="nickNameSureClick()">确 定</el-button>
        </span>
    </el-dialog>
    <!-- 账户信息模块修改手机号 -->
    <el-dialog
        title="变更手机号"
        :visible.sync="accountphoneDialog"
        width="30%"
        :before-close="accountphoneHandleClose"
        :close-on-click-modal="false">
      <el-form :model="changeUserInfo" label-width="90px">
        <template v-if="accountphoneStep === 1">
          <el-form-item prop="phone" label="原手机号码" >
            <el-input v-model="changeUserInfo.phone" placeholder="请输入原手机号码" disabled autocomplete="off" oninput="value=value.replace(/[^\d]/g,'')" maxlength="11">
              <template slot="prepend">+86</template>
            </el-input>
          </el-form-item>
          <el-form-item prop="verCode" label="验证码" >
            <el-input  v-model="changeUserInfo.verCode" maxlength="6" oninput="value=value.replace(/[^\d]/g,'')" placeholder="请输入验证码" autocomplete="off" class="input-with-select" >
              <el-button slot="append" style="height: 40px;border: none;padding: 0;width: 158px;">
                <CountDown v-show="showCount" ref="countdown" :url-type="11" :is-phone="true" :phone="changeUserInfo.phone" :form="changeUserInfo" :countdown-style="newCountdownStyle" @handleClick="clickBtn" />
              </el-button>
            </el-input>
          </el-form-item>
        </template>
        <template v-else-if="accountphoneStep === 2">
          <el-form-item prop="newphone" label="新手机号码" >
            <el-input v-model="changeUserInfo.newphone" placeholder="请输入新手机号码" autocomplete="off" oninput="value=value.replace(/[^\d]/g,'')" maxlength="11">
              <template slot="prepend">+86</template>
            </el-input>
          </el-form-item>
          <el-form-item prop="newVerCode" label="验证码" >
            <el-input  v-model="changeUserInfo.newVerCode" maxlength="6" oninput="value=value.replace(/[^\d]/g,'')" placeholder="请输入验证码" autocomplete="off" class="input-with-select" >
              <el-button slot="append" style="height: 40px;border: none;padding: 0;width: 158px;">
                <CountDown v-show="showCount" ref="countdown" :url-type="11" :is-phone="true" :phone="changeUserInfo.newphone" :form="changeUserInfo" :countdown-style="countdownStyle" @handleClick="clickBtn" />
              </el-button>
            </el-input>
          </el-form-item>
        </template>
        <template v-else>
          <div style="text-align: center;paddingTop: 20px">
            <img align="middle" style="width: 124px; height: 124px" src="../../../assets/img/usp/loginWasSuccessful.png" />
          </div>
          <div style="font-size: 14px;font-weight: 400;color: #000000;text-align: center;padding-top:20px">
            手机号变更成功！请重新登录。
          </div>
        </template>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" round :disabled="!canSubmit" @click="accountphoneSureClick()">{{ accountphonebuttontext }}</el-button>
        </span>
    </el-dialog>
    <!-- 基本信息模块修改手机号 -->
    <el-dialog
        title="修改手机号码"
        :visible.sync="phoneDialog"
        width="30%"
        :before-close="handleClose"
        :close-on-click-modal="false">
      <el-form :model="changeUserInfo">
        <el-form-item>
          <el-input v-model="changeUserInfo.phone" placeholder="请输入手机号码" autocomplete="off" oninput="value=value.replace(/[^\d]/g,'')" maxlength="11">
            <template slot="prepend">+86</template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input  v-model="changeUserInfo.verCode" maxlength="6" oninput="value=value.replace(/[^\d]/g,'')" placeholder="请输入验证码" autocomplete="off" class="input-with-select" >
            <el-button slot="append" style="height: 40px;border: none;padding: 0;width: 158px;">
              <CountDown v-show="showCount" ref="countdown" :url-type="11" :is-phone="true" :phone="changeUserInfo.phone" :form="changeUserInfo" :countdown-style="countdownStyle" @handleClick="clickBtn" />
            </el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" round :disabled="!canSubmit" @click="phoneSureClick()">确 定</el-button>
        </span>
    </el-dialog>
    <!--修改密码-->
    <el-dialog
        :title="'修改密码'"
        :visible.sync="updatePasswordDialog"
        width="40%"
        :before-close="handleClosePasswordDialog"
        :close-on-click-modal="false">
      <div v-if="!isPassWordSure">
        <el-form ref="emailPassWordForm" label-width="110px" label-style="display: flex;" :model="emailPassWordForm" status-icon :rules="passWordRules">
          <el-form-item prop="oldEmailPassword" label="旧密码：">
            <el-input class="input-template" v-model.trim="emailPassWordForm.oldEmailPassword" maxlength="30" type="password" autocomplete="off" show-password placeholder="请输入旧密码">
              <template slot="append" v-if="userInfo.source === '1'">
                <div class="template-class" @click="phoneForgotPassword()">忘记密码</div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="firstEmailPassword" label="新密码：">
            <el-input v-model.trim="emailPassWordForm.firstEmailPassword" maxlength="30" type="password" autocomplete="off" show-password placeholder="请输入新密码"></el-input>
          </el-form-item>
          <el-form-item prop="secondEmailPassword" label="重复新密码：">
            <el-input v-model.trim="emailPassWordForm.secondEmailPassword" maxlength="30" type="password" autocomplete="off" show-password placeholder="请再次输入新密码"></el-input>
          </el-form-item>
        </el-form>
        <div class="loginButtonDiv" style="text-align: center">
          <el-button  type="primary" round style="border: none;padding: 0px">
            <WaterproofWall v-show="showCount" :form="emailPassWordForm" @logInClickBtn="setPassWordSureClick"/>
          </el-button>
        </div>
      </div>
      <div v-else>
        <div style="text-align: center;paddingTop: 20px">
          <img align="middle" style="width: 124px; height: 124px" src="../../../assets/img/usp/loginWasSuccessful.png" />
        </div>
        <div style="font-size: 14px;font-weight: 400;color: #000000;text-align: center;padding-top:20px">
          密码变更成功！请重新登录。
        </div>
        <div style="width: 100%;text-align: center;padding-top:20px">
          <el-button style="width: 96px;height: 36px;background: #4D78FF;border-radius: 18px;color: #FFFFFF" size="small" @click="logoutClick()">重新登录</el-button>
        </div>
      </div>
    </el-dialog>
    <!--设置密码-->
    <el-dialog
        :title="phonePassword"
        :visible.sync="setPasswordDialog"
        width="40%"
        :before-close="handleCloseSetPasswordDialog"
        :close-on-click-modal="false">
      <div >
        <el-form ref="passWordForm" label-width="110px"  :model="passWordForm" status-icon :rules="setPassWordRules">
            <div v-if="setPassWordstep === '1'">
              <el-form-item  prop="phone" label="手机号：" >
                <el-input v-model="passWordForm.phone" placeholder="" disabled autocomplete="off">
                </el-input>
              </el-form-item>
              <el-form-item prop="code" label="验证码：" >
                <el-input v-model="passWordForm.code" maxlength="6" oninput="value=value.replace(/[^\d]/g,'')" placeholder="请输入验证码" autocomplete="off" class="input-with-select" >
                  <el-button slot="append" style="height: 40px;border: none;padding: 0;width: 158px;">
                    <CountDown v-show="showCount" ref="countdown" :url-type="13" :is-phone="true" :phone="passWordForm.phone" :form="passWordForm" :countdown-style="setPasswordCountdownStyle" @handleClick="clicksetPasswordBtn" />
                  </el-button>
                </el-input>
              </el-form-item>
              <div style="text-align: center">
                <el-button class="next-page-button" @click="firstSetPassword()">下一步</el-button>
              </div>
            </div>
            <div v-if="setPassWordstep === '2'">
              <el-form-item prop="firstPassword" label="新密码：">
                <el-input v-model.trim="passWordForm.firstPassword" type="password" autocomplete="off" show-password placeholder="请输入新密码"></el-input>
              </el-form-item>
              <el-form-item prop="secondPassword" label="重复新密码：">
                <el-input v-model.trim="passWordForm.secondPassword" type="password" autocomplete="off" show-password placeholder="请再次输入新密码"></el-input>
              </el-form-item>
            </div>
            <div v-if="setPassWordstep === '3'">
              <div style="text-align: center;paddingTop: 20px">
                <img align="middle" style="width: 124px; height: 124px" src="../../../assets/img/usp/loginWasSuccessful.png" />
              </div>
              <div style="font-size: 14px;font-weight: 400;color: #000000;text-align: center;padding-top:20px">
                密码设置成功！请重新登录。
              </div>
              <div style="width: 100%;text-align: center;padding-top:20px">
                <el-button style="width: 96px;height: 36px;background: #4D78FF;border-radius: 18px;color: #FFFFFF" size="small" @click="logoutClick()">重新登录</el-button>
              </div>
            </div>
        </el-form>
        <div style="text-align: center" v-if="setPassWordstep === '2'">
          <el-button class="next-page-button" @click="secondSetPassword()">下一步</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        title="修改性别"
        :visible.sync="sexDialog"
        width="30%"
        :before-close="handleClose"
        :close-on-click-modal="false">
      <el-form :model="changeUserInfo">
        <el-form-item>
          <el-select v-model="changeUserInfo.sex" placeholder="请选择性别" style="display: block;">
            <el-option label="未公开" value="0"></el-option>
            <el-option label="男" value="1"></el-option>
            <el-option label="女" value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" round @click="sexSureClick()">确 定</el-button>
        </span>
    </el-dialog>
    <el-dialog
        title="修改出生日期"
        :visible.sync="birthdayDialog"
        width="30%"
        :before-close="handleClose"
        :close-on-click-modal="false">
      <el-form :model="changeUserInfo">
        <el-form-item>
          <el-date-picker v-model="changeUserInfo.birthday" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" style="width: 100%;" placeholder="请选择日期" :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" round @click="birthdaySureClick()">确 定</el-button>
        </span>
    </el-dialog>
    <!-- 账户信息模块修改邮箱 -->
    <el-dialog
        title="变更邮箱"
        :visible.sync="accountemailDialog"
        width="30%"
        :before-close="accountemailHandleClose"
        :close-on-click-modal="false">
      <el-form :model="changeUserInfo">
        <template v-if="accountemailStep === 1">
          <el-form-item prop="email" label="原邮箱" >
            <el-input v-model="changeUserInfo.email" placeholder="请输入原邮箱" autocomplete="off" disabled>
              <template slot="append"><span class="appendText">{{ emailSuffix }}</span></template>
            </el-input>
          </el-form-item>
          <el-form-item prop="emailCode" label="验证码" >
            <el-input  v-model="changeUserInfo.emailCode" maxlength="6" oninput="value=value.replace(/[^\d]/g,'')" placeholder="请输入验证码" autocomplete="off" class="input-with-select" >
              <el-button slot="append" style="height: 40px;border: none;padding: 0;width: 158px;">
                <CountDown v-show="showCount" ref="countdown" :url-type="12" :is-phone="false" :email="changeUserInfo.email + emailSuffix" :form="changeUserInfo" :countdown-style="countdownStyle" @handleClick="clickBtn" />
              </el-button>
            </el-input>
          </el-form-item>
        </template>
        <template v-else-if="accountemailStep === 2">
          <el-form-item prop="newemail" label="新邮箱" >
            <el-input v-model="changeUserInfo.newemail" placeholder="请输入新邮箱" autocomplete="off">
              <template v-if="userInfo.source !== '1'" slot="append"><span class="appendText">{{ emailSuffix }}</span></template>
            </el-input>
          </el-form-item>
          <el-form-item prop="newemailCode" label="验证码" >
            <el-input  v-model="changeUserInfo.newemailCode" maxlength="6" oninput="value=value.replace(/[^\d]/g,'')" placeholder="请输入验证码" autocomplete="off" class="input-with-select" >
              <el-button slot="append" style="height: 40px;border: none;padding: 0;width: 158px;">
                <CountDown v-show="showCount" ref="countdown" :url-type="12" :is-phone="false" :email="changeUserInfo.newemail + emailSuffix" :form="changeUserInfo" :countdown-style="countdownStyle" @handleClick="clickBtn" />
              </el-button>
            </el-input>
          </el-form-item>
        </template>
        <template v-else>
          <div style="text-align: center;paddingTop: 20px">
            <img align="middle" style="width: 124px; height: 124px" src="../../../assets/img/usp/loginWasSuccessful.png" />
          </div>
          <div style="font-size: 14px;font-weight: 400;color: #000000;text-align: center;padding-top:20px">
            邮箱变更成功！请重新登录。
          </div>
        </template>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" :disabled="!canSubmit" round @click="accountemailSureClick()">{{ accountemailbuttontext }}</el-button>
        </span>
    </el-dialog>
    <!-- 基本信息模块修改邮箱 -->
    <el-dialog
        title="修改邮箱"
        :visible.sync="emailDialog"
        width="30%"
        :before-close="handleEmailClose"
        :close-on-click-modal="false">
      <el-form :model="changeUserInfo">
        <el-form-item>
          <el-input v-model="changeUserInfo.email" placeholder="请输入新邮箱" autocomplete="off">
            <template v-if="userInfo.source !== '1'" slot="append"><span class="appendText">{{ emailSuffix }}</span></template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input  v-model="changeUserInfo.emailCode" maxlength="6" oninput="value=value.replace(/[^\d]/g,'')" placeholder="请输入验证码" autocomplete="off" class="input-with-select" >
            <el-button slot="append" style="height: 40px;border: none;padding: 0;width: 158px;">
              <CountDown v-show="showCount" ref="countdown" :url-type="12" :is-phone="false" :email="changeUserInfo.email + emailSuffix" :form="changeUserInfo" :countdown-style="countdownStyle" @handleClick="clickBtn" />
            </el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" :disabled="!canSubmit" round @click="emailSureClick()">确 定</el-button>
        </span>
    </el-dialog>
    <el-dialog
        title="修改个人介绍"
        :visible.sync="introduceDialog"
        width="30%"
        :before-close="handleClose"
        :close-on-click-modal="false">
      <el-form :model="changeUserInfo">
        <el-form-item>
          <el-input v-model="changeUserInfo.introduce" type="textarea" maxlength="50" show-word-limit autocomplete="off" placeholder="请输入个人介绍" @input="introduceChangeClick()"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" :disabled="introduceDisabled" round @click="introduceSureClick()">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>
<script>
import { delCookie } from '@/scripts/delCookie'
import {
  accountLogOff,
  getUserInfo,
  phoneSubmit,
  emailSubmit,
  changePasswordVerify,
  changePasswordSubmit,
  resetSubmit,
  resetSetPassword,
  accountLogout
} from '@/api/modules/iam'
import { updateInfomation, getLoginLogs, isHavePasswordFunction, userChangePhone, userChangeEmail, getSignInfo, setSignin } from '@/api/modules/personalInfomation'
import store from '@/store/index'
import CountDown from '@/components/CountDown.vue'
import WaterproofWall from '@/components/WaterproofWall.vue'
import { remoteLoad } from '@/scripts/captcha'
import { getPasswordRSAV } from '@/scripts/utils'
import COS from 'cos-js-sdk-v5'
import { getUploadKey } from '@/api/modules/api'
import { getMilliData, getMilliHours } from '@/scripts/dataTimeUtils'
export default {
  name: 'ACCOUNT',
  components: {
    CountDown,
    WaterproofWall
  },
  data() {
    var validateOldPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入旧密码'))
      }
      else {
        callback()
      }
    }
    var validatePass = (rule, value, callback) => {
      const res = /^(?=.*[a-zA-Z])(?=.*\d).{6,12}$/
      if (value === '') {
        callback(new Error('请输入新密码'))
      }
      else {
        if (this.emailPassWordForm.secondEmailPassword !== '') {
          this.$refs.emailPassWordForm.validateField('secondEmailPassword')
        }
        if (!res.test(value)) {
          callback(new Error(' 至少包含字母、数字，6-12位'))
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      }
      else if (value !== this.emailPassWordForm.firstEmailPassword) {
        callback(new Error('两次输入密码不一致!'))
      }
      else {
        callback()
      }
    }
    var firstPasswordValidatePass = (rule, value, callback) => {
      const res = /^(?=.*[a-zA-Z])(?=.*\d).{6,12}$/
      if (value === '') {
        callback(new Error('请输入新密码'))
      }
      else {
        if (this.passWordForm.secondPassword !== '') {
          this.$refs.passWordForm.validateField('secondPassword')
        }
        if (!res.test(value)) {
          callback(new Error(' 至少包含字母、数字，6-12位'))
        }
        callback()
      }
    }
    var secondPasswordValidatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      }
      else if (value !== this.passWordForm.firstPassword) {
        callback(new Error('两次输入密码不一致!'))
      }
      else {
        callback()
      }
    }
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      nicknameDialog: false,
      accountphoneDialog: false,
      phoneDialog: false,
      updatePasswordDialog: false,
      setPasswordDialog: false,
      sexDialog: false,
      introduceDialog: false,
      birthdayDialog: false,
      emailDialog: false,
      accountemailDialog: false,
      getCode: '获取验证码',
      nicknameDisabled: true,
      introduceDisabled: true,
      showCount: true,
      showBirthday: '未公开',
      accountphoneStep: 1,
      accountemailStep: 1,
      accountphonebuttontext: '下一步',
      accountemailbuttontext: '下一步',
      tableData: [],
      userInfo: {},
      changeUserInfo: {
        'username': null,
        'phone': '',
        'email': '',
        'introduce': null,
        'sex': null,
        'birthday': null,
        'verCode': '',
        'newpassword': null,
        'emailCode': '',
        'remail': null,
        'newphone': null,
        'newVerCode': null,
        'newemail': null,
        'newemailCode': null
      },
      countdownStyle: {
        background: '#DDDDDD',
        color: '#FFFFFF',
        height: '40px',
        borderBottomLeftRadius: 'inherit',
        borderTopLeftRadius: 'inherit',
        width: '100%'
      },
      newCountdownStyle: {
        background: '#4d78ff',
        color: '#FFFFFF',
        height: '40px',
        borderBottomLeftRadius: 'inherit',
        borderTopLeftRadius: 'inherit',
        width: '100%'
      },
      canSubmit: false,
      inited: false,
      emailPassWordForm: {
        oldEmailPassword: '',
        firstEmailPassword: '',
        secondEmailPassword: ''
      },
      passWordRules: {
        oldEmailPassword: [
          { validator: validateOldPass, trigger: 'blur', required: true }
        ],
        firstEmailPassword: [
          { validator: validatePass, trigger: 'blur', required: true }
        ],
        secondEmailPassword: [
          { validator: validatePass2, trigger: 'blur', required: true }
        ]
      },
      emailSuffix: '',
      isHavePassword: true,
      isPassWordSure: false,
      passWordForm: {
        phone: '',
        code: '',
        firstPassword: '',
        secondPassword: ''
      },
      setPassWordstep: '1',
      setPassWordRules: {
        firstPassword: [
          { validator: firstPasswordValidatePass, trigger: 'blur', required: true }
        ],
        secondPassword: [
          { validator: secondPasswordValidatePass, trigger: 'blur', required: true }
        ]
      },
      nextPageButtonSubmit: false,
      setPasswordCountdownStyle: {
        background: '#4d78ff',
        color: '#FFFFFF',
        height: '40px',
        borderBottomLeftRadius: 'inherit',
        borderTopLeftRadius: 'inherit',
        width: '100%'
      },
      phonePassword: '设置密码',
      isCheckIn: false
    }
  },
  watch: {
    async $route(_to, _from) {
      if (!this.inited) {
        await this.init()
      }
    }
  },
  async created() {
    await this.init()
    this.getLoginLogs()
    const user = JSON.parse(localStorage.getItem('usersCurrentInfo'))
    this.userInfo = user
    console.log(this.userInfo)
    if (!this.isNull(this.userInfo.birthday)) {
      var data = new Date(this.userInfo.birthday)
      var Y = data.getFullYear()
      var M = data.getMonth() + 1
      var D = data.getDate()
      this.showBirthday = Y + '-' + M + '-' + D
    }
    if (user.source !== '1') {
      this.getEmailSuffix(user.email)
    }
    this.getSignInfo()
  },
  methods: {
    // 每日签到
    async checkClick() {
      const res = await setSignin()
      if (res.code === 0) {
        this.$message({
          message: '签到成功！',
          type: 'success'
        })
        this.getSignInfo()
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    // 查询签到状态
    async getSignInfo() {
      const res = await getSignInfo()
      if (res.code === 0) {
        if (res.data.signType === 0) {
          this.isCheckIn = false
        }
        else {
          this.isCheckIn = true
        }
      }
    },
    isNull(str) {
      if (str === '' || str === null) return true
      var regu = '^[ ]+$'
      var re = new RegExp(regu)
      return re.test(str)
    },
    // 获取邮箱后缀
    getEmailSuffix(email) {
      if (email === '' || email === '') {
        return ''
      }
      this.emailSuffix = '@' + email.substring(email.indexOf('@') + 1, email.length)
    },
    // 退出账号
    logoutClick() {
      const that = this
      this.$confirm('是否退出当前账号?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.accountLogout()
      }).catch(() => {
      })
    },
    // 注销当前帐号
    async logoffClick() {
      const that = this
      this.$confirm('是否注销当前账号?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.accountLogOff()
      }).catch(() => {
      })
    },
    // 调用注销接口
    async accountLogOff() {
      const that = this
      const res = await accountLogOff(this.userInfo.id)
      if (res.code === 0) {
        this.$message({
          message: '注销成功！即将跳转至首页！',
          type: 'success'
        })
        setTimeout(() => {
          delCookie()
          localStorage.removeItem('usersCurrentInfo')
          that.$router.push('/login')
        }, 1000)
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    nickNameClick() {
      this.nicknameDialog = true
      this.changeUserInfo.username = this.userInfo.name
    },
    nickNameSureClick() {
      this.nicknameDialog = false
      this.userInfo.username = this.changeUserInfo.username
      var data = { 'name': this.changeUserInfo.username }
      this.updateInfomation(data)
    },
    phoneClick() {
      if (this.userInfo.source === '1') {
        this.changeUserInfo.phone = this.userInfo.phone
        this.accountphoneDialog = true
      }
      else {
        this.phoneDialog = true
      }
    },
    async setPasswordClick() {
      const res = await isHavePasswordFunction()
      if (res.code === 0) {
        if (res.data) {
          this.passWordForm.phone = this.userInfo.phone
          this.setPasswordDialog = true
          this.setPassWordstep = '1'
        }
        else {
          this.isHavePassword = res.data
          this.updatePasswordDialog = true
        }
      }
    },
    // 账户信息-修改手机号
    async accountphoneSureClick() {
      if (this.accountphoneStep === 1) {
        if (this.changeUserInfo.verCode === '') {
          return this.$message({ message: '请输入验证码', type: 'warning' })
        }
        const res = await phoneSubmit({
          nation: '86',
          phone: this.changeUserInfo.phone,
          code: this.changeUserInfo.verCode
        })
        if (res.code === 0) {
          this.accountphoneStep = 2
          this.$refs.countdown.resetCode()
          this.accountphonebuttontext = '完成变更'
        }
        else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      }
      else if (this.accountphoneStep === 2) {
        if (this.changeUserInfo.newphone === '') {
          return this.$message({ message: '请输入手机号', type: 'warning' })
        }
        if (this.changeUserInfo.newVerCode === '') {
          return this.$message({ message: '请输入验证码', type: 'warning' })
        }
        const res = await phoneSubmit({
          nation: '86',
          phone: this.changeUserInfo.newphone,
          code: this.changeUserInfo.newVerCode
        })
        if (res.code === 0) {
          const res = await userChangePhone({ 'tinyId': this.userInfo.id, 'nation': '86', 'phone': this.changeUserInfo.newphone })
          if (res.code === 0) {
            this.$message({
              message: '修改成功！',
              type: 'success',
              duration: 1000
            })
            this.accountphoneStep = 3
            this.accountphonebuttontext = '重新登录'
          }
          else {
            this.$message({
              message: res.msg,
              type: 'error'
            })
          }
        }
        else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      }
      else {
        this.logoutClick()
      }
    },
    // 验证手机号验证码是否正确并且修改手机号
    async phoneSureClick() {
      const res = await phoneSubmit({
        nation: '86',
        phone: this.changeUserInfo.phone,
        code: this.changeUserInfo.verCode
      })
      if (res.code === 0) {
        this.updateInfomation({ 'phone': this.changeUserInfo.phone })
        this.changeUserInfo.phone = ''
        this.changeUserInfo.verCode = ''
        this.phoneDialog = false
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    sexClick() {
      this.sexDialog = true
      this.changeUserInfo.sex = this.userInfo.sex
    },
    sexSureClick() {
      this.sexDialog = false
      this.userInfo.sex = this.changeUserInfo.sex
      var data = { 'sex': this.changeUserInfo.sex }
      this.updateInfomation(data)
    },
    birthdayClick() {
      this.birthdayDialog = true
      this.changeUserInfo.birthday = this.userInfo.birthday
    },
    birthdaySureClick() {
      this.birthdayDialog = false
      this.userInfo.birthday = this.changeUserInfo.birthday
      var data = { 'birthday': this.changeUserInfo.birthday }
      this.showBirthday = this.changeUserInfo.birthday
      this.updateInfomation(data)
    },
    emailClick() {
      if (this.userInfo.source === '1') {
        this.emailDialog = true
        this.changeUserInfo.email = this.userInfo.email
      }
      else {
        this.accountemailDialog = true
        var index = this.userInfo.email.indexOf('@')
        this.changeUserInfo.email = this.userInfo.email.slice(0, index)
      }
    },
    // 账户模块邮箱修改
    async accountemailSureClick() {
      if (this.changeUserInfo.emailCode === '') {
        return this.$message({ message: '请输入验证码', type: 'warning' })
      }
      if (this.accountemailStep === 1) {
        const res = await emailSubmit({
          email: this.changeUserInfo.email + this.emailSuffix,
          code: this.changeUserInfo.emailCode
        })
        if (res.code === 0) {
          this.accountemailStep = 2
          this.$refs.countdown.resetCode()
          this.accountemailbuttontext = '完成变更'
        }
        else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      }
      else if (this.accountemailStep === 2) {
        if (this.changeUserInfo.newemail === '') {
          return this.$message({ message: '请输入新邮箱', type: 'warning' })
        }
        if (this.changeUserInfo.newemailCode === '') {
          return this.$message({ message: '请输入验证码', type: 'warning' })
        }
        const res = await emailSubmit({
          email: this.changeUserInfo.newemail + this.emailSuffix,
          code: this.changeUserInfo.newemailCode
        })
        if (res.code === 0) {
          const res = await userChangeEmail({ 'tinyId': this.userInfo.id, 'email': this.changeUserInfo.newemail + this.emailSuffix })
          if (res.code === 0) {
            this.$message({
              message: '修改成功！',
              type: 'success',
              duration: 1000
            })
            this.accountemailStep = 3
            this.accountemailbuttontext = '重新登录'
          }
          else {
            this.$message({
              message: res.msg,
              type: 'error'
            })
          }
          // this.updateInfomation({ 'email': this.changeUserInfo.newemail + this.emailSuffix })
        }
        else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      }
      else {
        this.logoutClick()
      }
    },
    // 验证邮箱验证码是否正确并且修改邮箱
    async emailSureClick() {
      const res = await emailSubmit({
        email: this.changeUserInfo.email,
        code: this.changeUserInfo.emailCode
      })
      if (res.code === 0) {
        this.updateInfomation({ 'email': this.changeUserInfo.email })
        this.changeUserInfo.email = ''
        this.changeUserInfo.emailCode = ''
        this.emailDialog = false
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    introducClick() {
      this.introduceDialog = true
      this.changeUserInfo.introduce = this.userInfo.introduce
    },
    introduceSureClick() {
      this.introduceDialog = false
      this.userInfo.introduce = this.changeUserInfo.introduce
      var data = { 'introduce': this.changeUserInfo.introduce }
      this.updateInfomation(data)
    },
    // 昵称输入监听
    nicknameChangeClick() {
      if (this.changeUserInfo.username.length === 0) {
        this.nicknameDisabled = true
      }
      else {
        this.nicknameDisabled = false
      }
    },
    // 个人介绍输入监听
    introduceChangeClick() {
      if (this.changeUserInfo.introduce === '' || this.changeUserInfo.introduce === null) {
        this.introduceDisabled = true
      }
      else {
        this.introduceDisabled = false
      }
    },
    async updateInfomation(data) {
      const res = await updateInfomation(data)
      if (res.code === 0) {
        this.$message({
          message: '修改成功！',
          type: 'success',
          duration: 1000
        })
        setTimeout(() => {
          this.userInfoFun()
        }, 1000)
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    async userInfoFun() {
      const res = await getUserInfo()
      if (res.code === 0) {
        this.userInfo = res.data
        localStorage.setItem('usersCurrentInfo', JSON.stringify(res.data))
        const setEvent = new Event('storage')
        setEvent.key = 'usersCurrentInfo'
        setEvent.newValue = JSON.stringify(res.data)
        window.dispatchEvent(setEvent)
        store.commit('userAuth/usersCurrentInfo', res.data)
      }
    },
    clickBtn(status) {
      this.canSubmit = status
    },
    async init() {
      setTimeout(() => {
        remoteLoad('https://turing.captcha.qcloud.com/TCaptcha.js')
      }, 10)
      this.inited = true
    },
    // 头像上传
    beforeUpload(file) {
      console.log(file)
      if (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg') {
        if (file.size < 500 * 1024) {
          this.$message.success('正在上传')
          return true
        }
        else {
          this.$message.error('图片大小不能超过500kb')
          return false
        }
      }
      this.$message.error('文件格式有误')
      return false
    },
    async cutomUpload(data) {
      console.log(data)
      const { file } = data
      const res = await getUploadKey(0)
      const cosKey = res.data
      console.log(cosKey)
      const cosKlg = new COS({
        getAuthorization: (options, callback) => {
          callback({
            TmpSecretId: cosKey.secretId,
            TmpSecretKey: cosKey.secretKey,
            XCosSecurityToken: cosKey.token,
            ExpiredTime: cosKey.expireTime
          })
        }
      })
      const key = 'web/img/' + new Date().getTime() + '-' + file.name
      cosKlg.putObject({
        Bucket: cosKey.bucket, // 指定桶参数coskey参
        Region: cosKey.region,
        Key: key, // this.sourcePath
        ContentType: 'application/octet-stream',
        StorageClass: 'STANDARD',
        Body: file,
        onProgress: function(progressData) {
          console.log(JSON.stringify(progressData))
        }
      }, (err, data) => {
        this.$message({
          message: '上传成功！',
          type: 'success'
        })
        this.updateInfomation({ 'headPortrait': 'http://' + data.Location })
        console.log(err || data)
      })
    },
    async getLoginLogs() {
      const res = await getLoginLogs({ 'pageNum': 0, 'pageSize': 10 })
      if (res.code === 0) {
        this.tableData = res.data.list
      }
    },
    getMilliData(data) {
      console.log(data)
      return getMilliData(data)
    },
    getMilliHours(data) {
      return getMilliHours(data)
    },
    setPassWordSureClick() {
      const that = this
      that.$refs['emailPassWordForm'].validate((valid) => {
        if (valid) {
          that.changePasswordVerify()
        }
        else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async changePasswordVerify() {
      const that = this
      let data = {}
      if (that.userInfo.source === '1') {
        data = {
          'nation': '86',
          'phone': that.userInfo.phone,
          'password': getPasswordRSAV(that.emailPassWordForm.oldEmailPassword),
          'captcha': that.emailPassWordForm.captcha
        }
      }
      else {
        data = {
          'email': that.userInfo.email,
          'password': getPasswordRSAV(that.emailPassWordForm.oldEmailPassword),
          'captcha': that.emailPassWordForm.captcha
        }
      }
      const res = await changePasswordVerify(data)
      if (res.code === 0) {
        const data = await changePasswordSubmit({ 'password': getPasswordRSAV(that.emailPassWordForm.firstEmailPassword) })
        if (data.code === 0) {
          this.isPassWordSure = true
          this.$message({
            message: '修改成功！',
            type: 'success',
            duration: 1000
          })
        }
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    handleClosePasswordDialog() {
      if (this.isPassWordSure) {
        this.forcedReturn()
      }
      this.$refs['emailPassWordForm'].resetFields()
      this.updatePasswordDialog = false
      this.isPassWordSure = false
      this.emailPassWordForm.oldEmailPassword = ''
      this.emailPassWordForm.firstEmailPassword = ''
      this.emailPassWordForm.secondEmailPassword = ''
    },
    async firstSetPassword() {
      const that = this
      if (that.passWordForm.code === '') {
        return this.$message({ message: '请输入验证码', type: 'warning' })
      }
      const res = await resetSubmit({ 'code': that.passWordForm.code })
      if (res.code === 0) {
        this.setPassWordstep = '2'
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    secondSetPassword() {
      const that = this
      that.$refs['passWordForm'].validate((valid) => {
        if (valid) {
          that.resetSetPassword()
        }
      })
    },
    async resetSetPassword() {
      const that = this
      const res = await resetSetPassword({ 'password': getPasswordRSAV(that.passWordForm.firstPassword) })
      if (res.code === 0) {
        this.setPassWordstep = '3'
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    handleCloseSetPasswordDialog() {
      this.setPasswordDialog = false
      this.setPassWordstep = '0'
      this.passWordForm.phone = ''
      this.passWordForm.code = ''
      this.passWordForm.firstPassword = ''
      this.passWordForm.secondPassword = ''
    },
    clicksetPasswordBtn(status) {
      this.nextPageButtonSubmit = status
    },
    handleEmailClose() {
      this.emailDialog = false
      this.changeUserInfo.email = ''
      this.changeUserInfo.emailCode = ''
    },
    accountphoneHandleClose() {
      if (this.accountphoneStep === '3') {
        this.forcedReturn()
      }
      this.accountphoneDialog = false
      this.accountphoneStep = 1
      this.changeUserInfo.phone = ''
      this.changeUserInfo.verCode = ''
      this.changeUserInfo.newphone = ''
      this.changeUserInfo.newVerCode = ''
    },
    accountemailHandleClose() {
      if (this.accountemailStep === '3') {
        this.forcedReturn()
      }
      this.accountemailDialog = false
      this.accountemailStep = 1
      this.changeUserInfo.email = ''
      this.changeUserInfo.emailCode = ''
      this.changeUserInfo.newemail = ''
      this.changeUserInfo.newemailCode = ''
    },
    // 强制退出
    async forcedReturn() {
      await accountLogout()
      delCookie()
      localStorage.removeItem('usersCurrentInfo')
      this.$router.push('/login')
    },
    phoneForgotPassword() {
      this.handleClosePasswordDialog()
      this.phonePassword = '忘记密码'
      this.passWordForm.phone = this.userInfo.phone
      this.setPasswordDialog = true
      this.setPassWordstep = '1'
    },
    async accountLogout() {
      const that = this
      await accountLogout()
      that.$message({
        message: '退出成功！即将跳转至登录页！',
        type: 'success',
        duration: 1000
      })
      setTimeout(() => {
        delCookie()
        localStorage.removeItem('usersCurrentInfo')
        that.$router.push('/login')
      }, 1000)
    }
  }
}
</script>
<style scoped>
.accountView{
  padding: 0px 20px;
  height: 100%;
}
.imageView{
  min-height: 600px;
  text-align: center;
}
.infoView{
  min-height: 600px;
}
.infoImage{
  margin-top: 36px;
  width: 120px;
  height: 120px;
}
.title{
  width: 100%;
  text-align: left;
  font-size: 18px;
  font-weight: 400;
  color: #2F374B;
  line-height: 30px;
}
.infocell{
  width: 100%;
  height: 40px;
  line-height: 40px;
}
.accountKey{
  font-size: 14px;
  font-weight: 400;
  color: #999999;
}
.accountValue{
  font-size: 14px;
  font-weight: 400;
  color: #2F374B;
}
.levelDetails{
  height: 24px;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  line-height: 24px;
}
.levelTable{
  padding: 30px 0px;
}
.changeBtn{
  margin-left: 40px;
}
.logoutButton{
  width: 136px;
  height: 36px;
  background: #FFFFFF;
  border: 1px solid #4D78FF;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  color: #4D78FF;
  padding: 0px;
}
.logoffButton{
  width: 136px;
  height: 36px;
  background: #FFFFFF;
  border: 1px solid #FF0000;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  color: #FF0000;
  padding: 0px;
}
/deep/.el-dialog{
  border-radius: 16px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
  border-radius: 50%
}
.next-page-button{
  width: 96px;
  height: 36px;
  background: #4D78FF;
  border-radius: 18px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
}
/deep/.el-dialog__footer{
  text-align: center;
}
/deep/ .input-template .el-input-group__append {
	border: none !important;
  background: #fff !important;
}
.template-class{
  cursor:pointer;
}
.el-button+.el-button{
  margin-left: 0px !important;
}
.checkButton{
  background: #FFFFFF;
  border: 1px solid #4D78FF;
  font-size: 16px;
  font-weight: 400;
  color: #4D78FF;
}
.checkedButton{
  background: #FFFFFF;
  border: 1px solid #999999;
  font-size: 16px;
  font-weight: 400;
  color: #999999;
}
</style>
